import React from 'react';

const MeetingInfo = ({ selectedApp, expired }) => {
    return (
        <div className="card-dark p-3 rounded mb-4" style={{background: '#131824', border: '1px solid #21293d'}}>
            <div className="fw-bold mb-2 text-white">Audition Mode & Meeting</div>
            <div className="p-3 bg-black rounded small">
                <div className="text-muted">Mode: <span className="text-white fw-bold">{selectedApp.bookingType}</span></div>
                <div className="text-muted mt-1">Schedule: <span className="text-white">{selectedApp.auditionDateTime || selectedApp.slot_datetime || 'Walk-in'}</span></div>
                {selectedApp.meetingLink && !expired && (
                    <div className="mt-2">
                        <a href={selectedApp.meetingLink} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-xs fw-bold" style={{fontSize: '0.75rem'}}>
                            🎥 Join Meeting Room
                        </a>
                    </div>
                )}
                {selectedApp.meetingLink && expired && (
                    <div className="mt-2">
                        <span className="badge bg-secondary text-light">Meeting Expired</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MeetingInfo;